/**
 * VG2 · AGISCI — op-id DETERMINISTICO del piano (logica pura, nessuna
 * dipendenza da rete/axios così da essere testabile sotto jest).
 *
 * §LAUNCH-B3 · L'op-id è legato allo scenario scelto e alla versione di
 * DECIDI (+ versione della scelta): il piano segue sempre la scelta
 * corrente. Se cambia lo scenario o DECIDI viene rigenerata (es. dopo
 * "Ricalcola"), l'op-id cambia e il backend ricostruisce il piano dallo
 * stato corrente (superando il precedente). Se nulla cambia, l'op-id resta
 * identico e il backend restituisce il piano già calcolato (idempotente).
 */
export function agisciOpIdForDecision(caseId, scenarioKey, decisionVersion, choiceVersion) {
  const s = scenarioKey || "none";
  const d = Number.isFinite(decisionVersion) ? decisionVersion : 0;
  const c = Number.isFinite(choiceVersion) ? choiceVersion : 0;
  return `aop:${caseId}:${s}:d${d}:c${c}`;
}
